import { createAsyncThunk } from "@reduxjs/toolkit";
import PageService from "../store/page.service";

export const fetchDataQrApi = createAsyncThunk(
  "page/fetchDataQrApi",
  async (page) => {
    try {
      const { data } = await PageService.fetchDataQrApi(page);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const postPage = createAsyncThunk("page/postPage", async (page) => {
  try {
    const { data } = await PageService.postPage(page);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const getPaymentProvider = createAsyncThunk(
  "page/getPaymentProvider",
  async () => {
    try {
      const { data } = await PageService.getPaymentProvider();
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const getVoucher = createAsyncThunk(
  "page/getVoucher",
  async (pageData) => {
    try {
      const { data } = await PageService.getVoucher(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const bookingTable = createAsyncThunk(
  "page/bookingTable",
  async (pageData) => {
    try {
      const { data } = await PageService.bookingTable(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const cancelBookingTable = createAsyncThunk(
  "page/cancelBookingTable",
  async (pageData) => {
    try {
      const { data } = await PageService.cancelBookingTable(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const getFavorite = createAsyncThunk(
  "page/getFavorite",
  async (pageData) => {
    try {
      const { data } = await PageService.getFavorite(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const getFavoriteMenu = createAsyncThunk(
  "page/getFavoriteMenu",
  async (pageData) => {
    try {
      const { data } = await PageService.getFavoriteMenu(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const addFavorite = createAsyncThunk(
  "page/addFavorite",
  async (pageData) => {
    try {
      const { data } = await PageService.addFavorite(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const delFavorite = createAsyncThunk(
  "page/delFavorite",
  async (pageData) => {
    try {
      const { data } = await PageService.delFavorite(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);

export const delFavoriteMenu = createAsyncThunk(
  "page/delFavoriteMenu",
  async (pageData) => {
    try {
      const { data } = await PageService.delFavoriteMenu(pageData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);
